import { render, staticRenderFns } from "./ModalSelecionarTerritoriosPy.vue?vue&type=template&id=28f6551c&lang=pug"
import script from "./ModalSelecionarTerritoriosPy.vue?vue&type=script&lang=js"
export * from "./ModalSelecionarTerritoriosPy.vue?vue&type=script&lang=js"
import style0 from "./ModalSelecionarTerritoriosPy.vue?vue&type=style&index=0&id=28f6551c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports